<script>
    import { DateInput } from "../../../Components/Common/index.svelte";

    export let formConfig = {};
</script>

<div class="artboard h-auto gap-4 p-6 shadow-lg w-full">
    <form
        class="flex flex-col w-full items-center gap-y-8"
        on:submit|preventDefault={{}}
    >
        <div class="flex flex-col w-full gap-y-2 lg:min-w-[500px]">
            <p
                class="required"
                style="color: {formConfig.textConfig
                    ?.color}; font-size: {formConfig.textConfig?.fontSize}px;"
            >
                Please enter your last name
            </p>
            <input
                type="text"
                placeholder="Your last name"
                class="input input-sm input-bordered shadow-md"
                disabled
            />
            <p
                class="opacity-70"
                style="color: {formConfig.textConfig
                    ?.color}; font-size: {formConfig.textConfig?.fontSize}px;"
            >
                If you do not have a last name, enter your first name instead.
            </p>
        </div>

        <div class="flex flex-col w-full gap-y-2 lg:min-w-[500px]">
            <p
                class="required"
                style="color: {formConfig.textConfig
                    ?.color}; font-size: {formConfig.textConfig?.fontSize}px;"
            >
                Date of birth
            </p>
            <div class="flex w-full shadow-md">
                <DateInput isDisable />
            </div>
        </div>

        <input
            class="btn w-full lg:min-w-[500px]"
            type="submit"
            value={formConfig.btnConfig?.btnText}
            style="color: {formConfig.btnConfig
                ?.textColor}; background-color: {formConfig.btnConfig
                ?.bgColor}; font-size: {formConfig.btnConfig?.fontSize}px;"
        />
    </form>
</div>

<style>
    .artboard {
        background-color: #f7f7f7;
        border: 1px solid rgba(65, 91, 63, 0.25);
        box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.1);
        border-radius: 15px;
    }

    .required::after {
        content: "*";
    }
</style>
